<div class="flex flex-col" *ngIf="vm$ | async">
	<form
		#form="ngForm"
		class="flex flex-col px-0.5 justify-between overflow-hidden gap-4"
	>
		<div class="flex flex-wrap">
			<ng-container
				class="flex flex-col justify-between"
				*ngFor="let lender of (vm$ | async).mortgage?.lenders | keyvalue"
			>
				<div
					*ngIf="lender.value | lenderLogoUrl"
					class="mt-4 mr-12 mb-4 flex-shrink-0"
				>
					<img
						[src]="'/assets/images/banks/' + (lender.value | lenderLogoUrl)"
						class="h-8 object-contain object-left object-fit w-auto"
					/>
				</div>
				<div
					*ngIf="!(lender.value | lenderLogoUrl)"
					class="flex mt-4 mr-12 mb-4"
				>
					<app-icon
						*ngIf="lender.value?.name"
						[icon]="ICON.MORTGAGE"
						class="text-2xl text-grey"
					></app-icon>
					<atomic-name-badge
						*ngIf="!lender.value?.name"
						[firstName]="lender.value?.client?.firstName ?? ''"
						[lastName]="lender.value?.client?.lastName ?? ''"
						[icon]="lender.value?.client?.name ? ICON.BUSINESS : null"
						size="small"
					></atomic-name-badge>
					<div class="pl-2 content-center">
						<h5 class="font-bold">
							{{
								lender.value?.name ||
									lender.value?.client?.name ||
									(lender.value?.client?.firstName ?? '') +
										' ' +
										(lender.value?.client?.lastName ?? '')
							}}
						</h5>
					</div>
				</div>
			</ng-container>
		</div>
		<span
			class="text-sm text-green hover:underline hover:cursor-pointer"
			(click)="goToItem(trustLedgerItem)"
		>
			Go to Mortgage Page
		</span>
		<app-input
			class="w-full"
			label="Title"
			[placeholder]="originalTitle"
			[(ngModel)]="description"
			(debounce)="updateDescription($event)"
			[required]="true"
			name="description"
		></app-input>
		<div class="text-sm text-grey">
			Original title: <span class="font-bold">{{ originalTitle }}</span>
		</div>
		<div class="flex w-fit mt-3">
			<app-checkbox
				size="small"
				[ngModel]="(vm$ | async).mortgage.hideItemization"
				[ngModelOptions]="{ standalone: true }"
				(ngModelChange)="updateHideItemization($event)"
				intercomAttr="hide-itemization-checkbox"
				>Hide itemization in Trust Ledger</app-checkbox
			>
		</div>
		<div class="mt-5" data-intercom-target="mortgage-loan-details">
			<h4>Loan Details</h4>
			<div class="mt-7">
				<h4 class="mb-5"></h4>
				<app-mortgage-net-amount
					[isMortgageDrawerOpen]="true"
					[forceErrorState]="forceErrorState && !(vm$ | async).mortgage.amount"
					[editable]="registeredEditable"
					[mortgage]="(vm$ | async).mortgage"
				></app-mortgage-net-amount>
			</div>
		</div>
	</form>
</div>
